import { memo } from "react";
interface IProps {
  imageUrl?: string;
  productName?: string;
}

export const CommandProduct = memo(({ imageUrl, productName }: IProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 pt-8 pb-12">
      {imageUrl && (
        <img
          src={imageUrl}
          className="w-[56px] max-auto max-h-20"
          alt="Product Logo"
        />
      )}
      {productName && (
        <span className="text-lg font-medium">{productName}</span>
      )}
    </div>
  );
});
